module.exports = __webpack_public_path__ + "img/white-header-3.fa92673e.png";